import normal from './normal';
import disabled from './disabled';
import hidden from './hidden';
import navDark from './nav-dark';
import navLight from './nav-light';
import navWhite from './nav-white';
import transparent from './transparent';

export default {
  normal,
  disabled,
  hidden,
  'nav-dark': navDark,
  transparent,
  'nav-dark-underline': {
    ...navDark,
    ':hover > div': { textDecoration: 'underline' },
  },
  'nav-dark-small': {
    ...navDark,
    fontSize: '12px',
    fontWeight: 700,
    ':hover': {
      color: 'gray900',
      textDecoration: 'none',
    },
    minHeight: '10px',
  },
  'nav-light': navLight,
  'nav-white': navWhite,
  'nav-transparent-small': {
    color: 'transparent',
    fontSize: '12px',
  },
};
